import { render } from "./SubCategories.vue?vue&type=template&id=d3b19f42&scoped=true"
import script from "./SubCategories.vue?vue&type=script&lang=js"
export * from "./SubCategories.vue?vue&type=script&lang=js"

import "./SubCategories.vue?vue&type=style&index=0&id=d3b19f42&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d3b19f42"

export default script